import React from "react";
import SidebarComp from "../../components/sidebar/sidebar";
import NavbarComp from "../../components/navbar/navbar";
import AllReportMainComp from "../../components/body/alldatacomponent/report/allreportmaincomp";

const AllReportScreen = () => {
    return (
        <div className="container-scroller">
            <NavbarComp />
            <div className="container-fluid page-body-wrapper">
                <SidebarComp />
                <div className="main-panel">
                    <div className="content-wrapper">
                        <AllReportMainComp />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AllReportScreen;